import { Controller } from "@hotwired/stimulus"

// UI-04: after `seconds` without a touch, key or scroll, open the screen saver,
// remembering the current page to come back to.
const EVENTS = ["pointerdown", "click", "touchstart", "keydown", "scroll"]

export default class extends Controller {
  static values = { url: String, seconds: { type: Number, default: 180 } }

  connect() {
    this.reset = this.reset.bind(this)
    EVENTS.forEach((type) => document.addEventListener(type, this.reset, { passive: true, capture: true }))
    this.reset()
  }

  disconnect() {
    EVENTS.forEach((type) => document.removeEventListener(type, this.reset, { capture: true }))
    clearTimeout(this.timer)
  }

  reset() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.sleep(), this.secondsValue * 1000)
  }

  sleep() {
    const returnTo = window.location.pathname + window.location.search
    window.Turbo.visit(`${this.urlValue}?return_to=${encodeURIComponent(returnTo)}`)
  }
}
